import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { List } from 'chaoskit/src/components'
import { gradient } from 'chaoskit/src/assets/styles/utility'
import { getComputedLineHeight } from 'chaoskit/src/assets/styles/utility/misc'

import plus from '~icons/plus.svg'

const PlusDecorationList = ({ columns, ...rest }) => {
  const theme = useTheme()

  return (
    <List
      space="base"
      css={[
        {
          fontWeight: theme.fontWeight.base,
          ...theme.text.medium,
          margin: 0,

          '> .CK__ListItem': {
            display: 'grid',
            gridAutoFlow: 'column',
            gridAutoColumns: 'auto',
            justifyContent: 'start',
            gap: theme.space.small,

            // 1. Calc for body copy offset
            '&::before': {
              content: "'\\200B'",
              width: getComputedLineHeight({
                fontSize: theme.fontSize.medium,
                lineHeight: theme.lineHeight.base,
              }),
              height: getComputedLineHeight({
                fontSize: theme.fontSize.medium,
                lineHeight: theme.lineHeight.base,
              }),
              maskImage: `url(${plus})`,
              maskSize: '75%',
              maskPosition: 'center center',
              ...gradient.tealGreen(theme),
            },
          },
        },

        columns && {
          [theme.mq.medium]: {
            gridTemplateColumns: '1fr 1fr',
          },
        },
      ]}
      {...rest}
    />
  )
}

PlusDecorationList.propTypes = {
  columns: PropTypes.bool,
}

export default PlusDecorationList
